module.exports = __webpack_public_path__ + "img/NOR.d7b21049.svg";